import { TrashIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportSectionsType, useDeleteReportSectionMutation } from "@api/graphql/types-and-hooks";
import { ConfirmationDialog } from "@components/ConfirmationDialog/ConfirmationDialog";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

interface ItemProps {
  onOpen: () => void;
}

export const ReportSectionActionMenuRemoveItem: React.FC<ItemProps> = ({ onOpen }) => {
  return (
    <DropdownMenuItem variant="destructive" onClick={onOpen}>
      <TrashIcon />
      Delete
    </DropdownMenuItem>
  );
};

interface DialogProps {
  section: ReportSectionsType;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ReportSectionActionMenuRemoveDialog: React.FC<DialogProps> = ({ section, open, onOpenChange }) => {
  const { report, reportQuery } = useReport();
  const { mutate: deleteSectionMutate, isPending } = useDeleteReportSectionMutation({
    onSuccess: async (data) => {
      if (data.deleteReportSection?.status) {
        await reportQuery.refetch();
      } else if (data.deleteReportSection?.status === false) {
        notifyError(data.deleteReportSection?.message ?? "Error Deleting Section");
      }
    },
    onError: (error) => {
      console.error("Error while deleting section:", error);
      notifyError("Error Deleting Section");
    },
    onSettled: () => {
      onOpenChange(false);
    },
  });

  return (
    <ConfirmationDialog
      open={open}
      title="Delete this section?"
      content="This will permanently delete the section and all fields inside it. Are you sure you want to continue?"
      submitButtonText="Yes, Delete"
      submitButtonLoading={isPending}
      cancelButtonText="No, Cancel"
      cancelButtonAction="destructive"
      submitButtonAction="destructive"
      onSubmitClick={() => deleteSectionMutate({ reportId: report.id, reportSectionId: section.id })}
      onCancelClick={() => onOpenChange(false)}
    />
  );
};
